<template>
    <div>
        <div class="flex justify-between">
            <div class="flex" style="width: 500px">
                <el-input class="Comipt" size="small" :placeholder="$t('btn.search')" suffix-icon="el-icon-search"
                    v-model="searchValue" @keyup.enter.native="getList">
                </el-input>
            </div>
            <el-button type="primary" @click="editDialogVisible = true;" size="mini">Add Product</el-button>
        </div>
        <div class="box-card barging-table" v-bind:class="{ 'mobile-view': isMobileScreen }">
            <div class="w-full Comtable" id="shipVettTable" ref="shipVettTableRef">
                <el-table key="shipVettingList" :data="listData" :header-cell-style="{
                    height: '55px',
                    background: '#fff',
                    'border-bottom': '2px solid #D6D9E1',
                }" :cell-style="getCellStyle" table-layout="auto" height="100%">
                    <el-table-column align="center" prop="productName" :label="'Product Name'" min-width="620">
                    </el-table-column>
                    <el-table-column align="center" :label="'Action'" min-width="620">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini"
                                @click.stop="() => { editDialogVisible = true; isEditing = true; editForm.id = scope.row.id; editForm.productName = scope.row.productName }">Edit</el-button>
                            <el-button type="danger" size="mini"
                                @click.stop="() => { deleteDialogVisible = true; editForm.id = scope.row.id }">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :title="isEditing ? 'Edit Product' : 'Add Product'" :visible.sync="editDialogVisible" width="30%"
            @close="handleCancelClick">
            <el-form :model="editForm" :rules="rules" ref="editFormRef">
                <el-form-item label="Product Name" :label-width="formLabelWidth" prop="productName">
                    <el-input v-model="editForm.productName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancelClick">Cancel</el-button>
                <el-button type="primary" @click="handleConfirmClick">Confirm</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Delete Product" :visible.sync="deleteDialogVisible" width="30%">
            <span>Are you sure you want to delete this product?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancelClick">Cancel</el-button>
                <el-button type="primary" @click="handleDeleteClick">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getProductList } from "@/services";
import { addProductM, deleteProduct, updateProduct } from "@/services/form";

export default {
    name: "requests",
    components: {},

    data() {
        return {
            listData: [],
            searchValue: "",
            options: [],
            selectDate: "",
            pageParams: {
                pageNum: 1,
                pageSize: 50,
            },
            total: 0,
            editDialogVisible: false,
            editForm: {
                id: null,
                productName: "",
            },
            deleteDialogVisible: false,
            isEditing: false,
            rules: {
                productName: [
                    { required: true, message: " ", trigger: "blur" }
                ]
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            const params = {
                searchValue: this.searchValue
            };

            getProductList(params).then((res) => {
                this.listData = res.data;
            });
        },
        getCellStyle({ rowIndex }) {
            if (rowIndex % 2 === 1) {
                return {
                    backgroundColor: "rgba(255,255,255,0.2)",
                };
            } else {
                return {
                    backgroundColor: "rgba(228,228,228,0.2)",
                };
            }
        },
        handleDeleteClick() {
            deleteProduct(this.editForm.id).then(() => {
                this.$message.success("Product deleted successfully");
                this.getList();
                this.editForm = { id: null, productName: "" };
                this.deleteDialogVisible = false;
            });
        },
        handleCancelClick() {
            this.editDialogVisible = false;
            this.deleteDialogVisible = false;
            this.editForm = { id: null, productName: "" };
            this.isEditing = false;
            this.$refs.editFormRef.clearValidate();
        },
        handleConfirmClick() {
            this.$refs.editFormRef.validate((valid) => {
                if (!valid) return;

                if (this.isEditing) {
                    updateProduct({ ...this.editForm }).then(() => {
                        this.$message.success("Product updated successfully");
                        this.getList();
                        this.editDialogVisible = false;
                        this.editForm = { id: null, productName: "" };
                        this.isEditing = false;
                    });
                } else {
                    addProductM({ ...this.editForm }).then(() => {
                        this.$message.success("Product added successfully");
                        this.getList();
                        this.editForm = { id: null, productName: "" };
                        this.editDialogVisible = false;
                    });
                }
            });
        }

    },
};
</script>

<style scoped lang="scss">
.Topinp {
    position: relative;
}

.Topinput {
    display: flex;
    position: absolute;
    top: -65px;
    right: -40px;

    .Comipt {
        width: 275px;
        height: 46px;
    }

    .Pendingselect {
        width: 221px;
        height: 46px;
        margin-left: 16px;
    }
}

.Reqcol {
    display: flex;
    justify-content: center;
    height: calc(90vh - 80px - 32 * 2px - 56px);
    overflow-y: scroll;

    .ReqTable {
        width: 1000px;
    }

    .el-button--default {
        color: #fff;
        background-color: #008CDB;
    }

    .el-button--default.is-plain:hover {
        color: #fff;
        background: #008CDB;
        border-color: #008CDB;
    }

    .el-button--default:focus {
        color: #fff !important;
        background: #008CDB !important;
        border-color: #008CDB;
    }
}

::v-deep {
    .el-input__icon.el-icon-search {
        height: 32px !important;
    }
}

::v-deep .Comtable .el-table div {
    word-break: break-word !important;
}

@media (max-width: 1023px) {
    .Comtable {
        height: calc(100vh - 175px);
    }

    .mobile-view {
        .Comtable {
            height: calc(100vh - 115px);
        }
    }
}

@media (min-width: 1024px) {
    .Comtable {
        height: calc(100vh - 180px);
    }
}

.barging-table {
    overflow: hidden;
    box-sizing: border-box;
    height: 100%;
    margin-block: 14px;
    border-radius: 10px;
}
</style>